import React, { FC } from "react";
import "./ComingSoonLabel.css";

interface ComingSoonLabelProps {}

const ComingSoonLabel: FC<ComingSoonLabelProps> = () => (
  <div className="ComingSoonLabel">
    <span>Coming Soon</span>
  </div>
);

export default ComingSoonLabel;
